import React, { useState } from 'react';
import CommonTable from '../../../global/table';
import CommonCardView from '../../../global/cardView';
import NoRecordFound from '../../../global/noRecordFound';
import CommonDrawer from '../../../global/drawer';
import { formatDateTime } from '../../../../utils/functions';
import EnhancedActivityLogCardView from './EnhancedActivityLogCardView';
import EnhancedActivityLogDetails from './EnhancedActivityLogDetails';

const EnhancedActivityLogList = ({
    isLoading,
    activityLogData,
    sort,
    setSort,
    viewType
}) => {
    const [detailsDrawer, setDetailsDrawer] = useState({
        show: false,
        data: null
    });

    const columns = [
        {
            title: "Description",
            dataIndex: "description",
            key: "description",
            // Typically sort isn't supported on description in old code, only date. 
            // But leaving standard config if user wants to implement later.
        },
        {
            title: "Occurred At",
            dataIndex: "dateAsPerUserTimezone",
            key: "dateAsPerUserTimezone",
            sortType: "dateAsPerUserTimezone",
            render: (text) => formatDateTime(text)
        }
    ];

    const handleRowClick = (record) => {
        setDetailsDrawer({ show: true, data: record });
    };

    return (
        <>
            {activityLogData && activityLogData.length > 0 ? (
                <>
                    {viewType === "LIST" ? (
                        <CommonTable
                            columns={columns}
                            data={activityLogData.map((item, index) => ({
                                key: item._id || index,
                                ...item
                            }))}
                            sort={sort}
                            setSort={setSort}
                            onRowClick={handleRowClick}
                        />
                    ) : (
                        <CommonCardView>
                            {activityLogData.map((record, index) => (
                                <EnhancedActivityLogCardView
                                    key={record._id || index}
                                    record={record}
                                    onCardClick={handleRowClick}
                                />
                            ))}
                        </CommonCardView>
                    )}
                </>
            ) : (
                <NoRecordFound message="No activity logs found." />
            )}

            {detailsDrawer.show && (
                <CommonDrawer
                    open={detailsDrawer.show}
                    setOpen={(val) => setDetailsDrawer(prev => ({ ...prev, show: val }))}
                    title="Activity Log Details"
                    width="600px"
                >
                    <EnhancedActivityLogDetails data={detailsDrawer.data} />
                </CommonDrawer>
            )}
        </>
    );
};

export default EnhancedActivityLogList;
